// Option lists for the Flat add/edit form.

export const PROPERTY_TYPE_OPTIONS = [
    { value: 'RESIDENTIAL', label: 'Residential' },
    { value: 'COMMERCIAL', label: 'Commercial' },
];
